import axios from "../axios";
import {
    GET_ALL_TASKS,
    GET_ALL_TASKS_OF_TODAY,
    GET_ALL_TASKS_OF_USER,
    GET_ALL_TASKS_OF_TODAY_OF_USER,
    GET_ALL_TASKS_OF_CUSTOMER,
    GET_TASK_DETAILS,
    ADD_TASK,
    UPDATE_TASK,
    DELETE_TASK_DETAILS,
    TASKS_LOADING,
} from "./types";
import {tokenConfig} from "./authActions";
import {returnErrors} from "./errorActions";
import {func} from "prop-types";
import moment from 'moment';

export const getAllTasks = () => dispatch => {
    dispatch(setTasksLoading());
    axios
        .get('/api/tasks')
        .then(res => {
            let data = res.data;
            for(let i = 0; i< res.data.length; i++){
                data[i] = {
                    ...data[i],
                    id: i+1,
                }
            }
            dispatch({
                type: GET_ALL_TASKS,
                payload: {
                    data: data,
                    errorMessage: false
                }
            })
        })
        .catch(err => {
            dispatch({
                type: GET_ALL_TASKS,
                payload: {
                    data: false,
                    errorMessage: err?.message
                }
            })
        })
};
export const getAllTasksOfToday = () => dispatch => {
    dispatch(setTasksLoading());
    axios
        .get('/api/tasks/today')
        .then(res => {
            let data = res.data;
            for(let i = 0; i< res.data.length; i++){
                data[i] = {
                    ...data[i],
                    id: i+1,
                }
            }
            dispatch({
                type: GET_ALL_TASKS_OF_TODAY,
                payload: {
                    data: data,
                    errorMessage: false
                }
            })
        })
        .catch(err => {
            dispatch({
                type: GET_ALL_TASKS_OF_TODAY,
                payload: {
                    data: false,
                    errorMessage: err?.message
                }
            })
        })
};

export const getAllTasksOfCustomer = (id) => dispatch => {
    dispatch(setTasksLoading());
    axios
        .get('/api/tasks/customer/' + id )
        .then(res => {
            let data = res.data;
            for(let i = 0; i< res.data.length; i++){
                data[i] = {
                    ...data[i],
                    id: i+1,
                }
            }
            dispatch({
                type: GET_ALL_TASKS_OF_CUSTOMER,
                payload: {
                    data: data,
                    errorMessage: false
                }
            })
        })
        .catch(err => {
            dispatch({
                type: GET_ALL_TASKS_OF_CUSTOMER,
                payload: {
                    data: false,
                    errorMessage: err?.message
                }
            })
        })
};

export const getAllTasksOfUser = (id) => dispatch => {
    dispatch(setTasksLoading());
    axios
        .get('/api/tasks/user/' + id )
        .then(res => {
            let data = res.data;
            for(let i = 0; i< res.data.length; i++){
                data[i] = {
                    ...data[i],
                    id: i+1,
                }
            }
            dispatch({
                type: GET_ALL_TASKS_OF_USER,
                payload: {
                    data: data,
                    errorMessage: false
                }
            })
        })
        .catch(err => {
            dispatch({
                type: GET_ALL_TASKS_OF_USER,
                payload: {
                    data: false,
                    errorMessage: err?.message
                }
            })
        })
};

export const getAllTasksOfTodayOfUser = (id) => dispatch => {
    dispatch(setTasksLoading());
    axios
        .get('/api/tasks/today/user/'+ id)
        .then(res => {
            let data = res.data;
            for(let i = 0; i< res.data.length; i++){
                data[i] = {
                    ...data[i],
                    id: i+1,
                }
            }
            dispatch({
                type: GET_ALL_TASKS_OF_TODAY_OF_USER,
                payload: {
                    data: data,
                    errorMessage: false
                }
            })
        })
        .catch(err => {
            dispatch({
                type: GET_ALL_TASKS_OF_TODAY_OF_USER,
                payload: {
                    data: false,
                    errorMessage: err?.message
                }
            })
        })
};

export const getTaskDetails = (id) => {
    return (dispatch) => {
    axios
        .get('/api/tasks/' + id)
            .then(function (response){
                dispatch({
                    type: GET_TASK_DETAILS,
                    payload: {
                        data: response?.data,
                        errorMessage: false,
                    }
                })
        })
        .catch(function (error) {
            dispatch({
                type: GET_TASK_DETAILS,
                payload: {
                    data: false,
                    errorMessage: error?.message,
                }
            })
        })
    }
}

export const addtask = (data) => {
    return (dispatch, getState) => {
        dispatch(setTasksLoading());
        axios
        .post('/api/tasks', data, tokenConfig(getState))
            .then(function (response) {
                    dispatch({
                        type: ADD_TASK,
                        payload: {
                            data: response?.data,
                            errorMessage: false
                        },
                    });
            })
            .catch(function (error){
                dispatch({
                    type: ADD_TASK,
                    payload: {
                        data: false,
                        errorMessage: error?.message,
                    }
                });
        })
    };
}

/*export const addTask = task => (dispatch, getState) => {
    axios
        .post('/api/tasks', task, tokenConfig(getState))
        .then(res =>
            dispatch({
                type: ADD_TASK,
                payload: res.data
            })
        ).catch(err => dispatch(returnErrors(err.response.data, err.response.status)))
};*/

export const updateTask = (task, id) => {
    return (dispatch, getState) => {
        axios
            .put("/api/tasks/"+id, task, tokenConfig(getState))
            .then(function (response) {
                dispatch({
                    type: UPDATE_TASK,
                    payload: {
                        data: response?.data,
                        errorMessage: false,
                    },
                });
            })
            .catch(function (error) {
                dispatch({
                    type: UPDATE_TASK,
                    payload: {
                        data: false,
                        errorMessage: error?.message
                    },
                });
            })
    };
}

    export const deleteDataTask = () => {
        return (dispatch) => {
            dispatch({
                type: GET_TASK_DETAILS,
                payload: {
                    data: false,
                    errorMessage: false,
                }
            });
            dispatch({
                type: ADD_TASK,
                payload: {
                    data: false,
                    errorMessage: false,
                }
            });
        }
    }

    export const deleteTask = id => (dispatch, getState) => {
        dispatch(setTasksLoading());
        axios
            .delete(`/api/tasks/${id}`, tokenConfig(getState))
            .then(res =>
                dispatch({
                    type: DELETE_TASK_DETAILS,
                    payload: id
                })
            ).catch(err => dispatch(returnErrors(err?.response?.data, err?.response?.status)))
    };

    export const setTasksLoading = () => {
        return {
            type: TASKS_LOADING,
        };
    };

